// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d79c78a9","455":"e2fa8fbb","977":"254e8ddd"}[chunkId] + ".chunk.js";
};